export default __webpack_public_path__ + "static/media/Fresh-Air.08db6d46.gif";